<!-- HEADER -->
<header>
    <div class="container nav" role="navigation" aria-label="Principale">
        <div class="logo" aria-label="Logo">
            <span class="logo-mark" aria-hidden="true"></span>
            <span>Presenze Smart</span>
        </div>
        <nav class="nav-links" id="menu">
            <a href="#funzionalita">Funzionalità</a>
            <a href="#app-mobile">App Mobile</a>
            <a href="#prezzi">Prezzi</a>
            <a href="#come-funziona">Come funziona</a>
            <a href="#sicurezza">Sicurezza & GDPR</a>
            <a href="#integrazioni">Integrazioni</a>
            <a href="#risorse">Risorse</a>
            <a href="#contatti">Contatti</a>
            <a class="cta ghost" href="#assistenza">Assistenza</a>
            <a class="cta" href="/prova-gratuita" aria-label="Prova gratuita 30 giorni">Prova gratuita</a>
        </nav>
        <button class="burger" id="burger" aria-label="Apri menu">&#9776;</button>
    </div>
</header>
<main class="app-main">
    <router-outlet></router-outlet>
</main>
<!-- FOOTER -->
<footer role="contentinfo">
    <div class="container footer-grid">
        <div>
            <div class="logo" style="color:#e2e8f0">
                <span class="logo-mark" aria-hidden="true"></span>
                <span>Presenze Smart</span>
            </div>
            <p class="small">© <span id="year"></span> Presenze Smart. Tutti i diritti riservati.</p>
            <p class="small">Server in UE • Sicurezza by design • DPA su richiesta</p>
        </div>
        <div>
            <strong>Prodotto</strong><br>
            <a href="#funzionalita">Funzionalità</a><br>
            <a href="#app-mobile">App Mobile</a><br>
            <a href="#prezzi">Prezzi</a><br>
            <a href="#integrazioni">Integrazioni</a>
        </div>
        <div>
            <strong>Azienda</strong><br>
            <a href="#contatti">Contatti</a><br>
            <a href="#note-legali">Note legali</a><br>
            <a href="#sicurezza">Sicurezza & GDPR</a>
        </div>
        <div>
            <strong>Risorse</strong><br>
            <a href="#risorse">Blog & Guide</a><br>
            <a href="#assistenza">Assistenza</a><br>
            <a href="/prova-gratuita">Prova gratuita</a>
        </div>
    </div>
    <script>document.getElementById('year').textContent = new Date().getFullYear();</script>
</footer>
